function updateMainImage(card, imageUrl) {
  const image = card.querySelector(".card-category-image");
  if (image && imageUrl) {
    const preload = new Image();
    preload.src = imageUrl;
    preload.onload = () => {
      image.src = imageUrl;
    };
  }
}

function updateBadges(card, variantId) {
  card.querySelectorAll(".product-card-badge").forEach(badge => {
    badge.classList.toggle("hidden", badge.dataset.variantId !== variantId);
  });
}

document.querySelectorAll(".card__color-swatch").forEach(swatch => {
  const card = swatch.closest(".product-card-wrapper");

  swatch.addEventListener("click", function () {
    const variantId = swatch.dataset.variantId;
    const imageUrl = swatch.dataset.image;
    const newUrl = swatch.dataset.url;

    // Update selected swatch
    card.querySelectorAll(".card__color-swatch").forEach(el => el.classList.remove("selected"));
    swatch.classList.add("selected");

    updateMainImage(card, imageUrl);
    updateBadges(card, variantId);

    // Update product link href
    if (newUrl) {
      const links = card.querySelectorAll("a[href^='/products/']");
      links.forEach(link => {
        link.setAttribute("href", newUrl);
      });
    }
    const atcId = card.querySelector("[name='id']");
    const atcButton = card.querySelector("[name='add']");
    const priceWrapper = card.querySelector(".product-card-prices");

    if (atcId) atcId.value = variantId;

    if (swatch.dataset.compareprice > swatch.dataset.price) {
      priceWrapper.classList.add('has-discount');
      priceWrapper.innerHTML = `<span>${swatch.dataset.price}</span> <span class="subdued strikethrough">${swatch.dataset.compareprice}</span>`;
    } else {
      priceWrapper.classList.add('has-discount');
      priceWrapper.innerHTML = `<span>${swatch.dataset.price}</span>`;
    }

    if (swatch.dataset.available === "false") {
      atcButton.setAttribute("disabled", "");
      atcButton.querySelector("span").innerText = "Sold Out";
    } else {
      atcButton.removeAttribute("disabled");
      atcButton.querySelector("span").innerText = "Add To Cart";
    }
  });

  swatch.addEventListener("mouseenter", function () {
    updateMainImage(card, swatch.dataset.image);
    console.log("Swapping image to:", swatch.dataset.image);

    updateBadges(card, swatch.dataset.variantId);
  });

  swatch.addEventListener("mouseleave", function () {
    const selectedSwatch = card.querySelector(".card__color-swatch.selected");
    if (!selectedSwatch) return;

    updateMainImage(card, selectedSwatch.dataset.image);
    updateBadges(card, selectedSwatch.dataset.variantId);
  });
});



// Show hidden swatches when reveal button is clicked
document.querySelectorAll("[data-reveal-swatches]").forEach(button => {
  button.addEventListener("click", () => {
    const swatchContainer = button.closest(".swatches");
    if (!swatchContainer) return;

    swatchContainer.querySelectorAll(".hidden").forEach(swatch => {
      swatch.classList.remove("hidden");
    });

    button.classList.add("hidden");
  });
});


// const pdpSwatches = document.querySelectorAll('.product-page-swatch');
// [...pdpSwatches]
//   .sort((a, b) => a.dataset.order - b.dataset.order)
//   .slice(0, 3)
//   .forEach(swatch => swatch.classList.remove('hidden'));

// Show top 3 card swatches (sorted by data-order)
document.querySelectorAll('.card__color-swatches').forEach(wrapper => {
  const swatches = wrapper.querySelectorAll('.card__color-swatch');

  if (swatches.length <= 3) {
    swatches.forEach(swatch => swatch.classList.remove('hidden'));
    return;
  }

  [...swatches]
    .sort((a, b) => a.dataset.order - b.dataset.order)
    .slice(0, 3)
    .forEach(swatch => swatch.classList.remove('hidden'));
});


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('product-form').forEach(function (productFormComponent) {
    const form = productFormComponent.querySelector('form[data-type="add-to-cart-form"]');
    const priorityCheckbox = productFormComponent.querySelector('[data-priority-checkbox]');

    if (!(form instanceof HTMLFormElement) || !priorityCheckbox) return;

    form.addEventListener('submit', function (e) {
      const priorityVariantId = priorityCheckbox.getAttribute('data-priority-variant-id');
      if (!priorityCheckbox.checked || !priorityVariantId) return;

      e.preventDefault();

      const formData = new FormData(form);
      const mainProductData = new URLSearchParams(formData);
      const mainVariantId = formData.get('id');

      // Step 1: Add the main product first
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: mainProductData.toString()
      })
        .then(response => {
          if (!response.ok) throw new Error('Main product add failed');
          return response.json();
        })
        .then(() => {
          const upsellData = {
            id: parseInt(priorityVariantId),
            quantity: 1,
            properties: {
              _added_with_variant: mainVariantId
            }
          };

          console.log('🧾 Adding priority upsell with properties:', upsellData);

          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [upsellData] })
          });
        })

        .then(() => {
          // Step 3: Refresh cart drawer
          return fetch(`${routes.cart_url}?section_id=cart-drawer`);
        })
        .then(response => response.text())
        .then(responseText => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          ['cart-drawer-items', '.cart-drawer__footer'].forEach(selector => {
            const target = document.querySelector(selector);
            const source = html.querySelector(selector);
            if (target && source) target.replaceWith(source);
          });

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.classList.add('is-open');
            document.body.classList.add('overflow-hidden');
          }
        })
        .catch(error => {
          console.error('[Priority Upsell] Error:', error);
          alert('There was a problem adding your items to the cart.');
        });
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(() => {
      const widget = document.getElementById("__ss-widget-button");

      if (widget && !document.getElementById("ss-widget-close-btn")) {
        // Update font size of the content
        const content = document.getElementById("__ss-widget-button-content");
        if (content) {
          content.style.fontSize = "12px";
        }

        // Create close button
        const closeBtn = document.createElement("span");
        closeBtn.id = "ss-widget-close-btn";
        closeBtn.innerText = "✕";

        // Style the close button with your new CSS
        Object.assign(closeBtn.style, {
          marginLeft: "0",
          cursor: "pointer",
          fontSize: "14px",
          fontWeight: "bold",
          padding: "0px 6px",
          borderRadius: "50%",
          position: "absolute",
          top: "-10px",
          left: "-10px",
          background: "rgba(255, 255, 255, 0.9)",
          zIndex: "10000"
        });

        // Prevent close button click from bubbling to the widget
        closeBtn.addEventListener("click", function (e) {
          e.stopPropagation();
          widget.style.display = "none";
        });

        // Append the close button
        widget.appendChild(closeBtn);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });